import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIState {
  loading: boolean;
  error: string | null;
  activeView: 'analyst' | 'executive' | 'tenant';
  sidebarOpen: boolean;
}

const initialState: UIState = {
  loading: false,
  error: null,
  activeView: 'analyst',
  sidebarOpen: true,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setActiveView: (state, action: PayloadAction<UIState['activeView']>) => {
      state.activeView = action.payload;
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { setLoading, setError, setActiveView, toggleSidebar, clearError } = uiSlice.actions;
export default uiSlice.reducer;
